import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Ic } from './Icons';
import { NAV } from './Rail';
import { useTheme } from './ThemeContext';

export default function MobileHub({ open, onClose, onLogout }) {
  const location = useLocation();
  const { theme, toggleTheme } = useTheme();
  if (!open) return null;

  const today = new Date();
  const dateStr = today.toLocaleDateString('fr-FR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  }) + ' · ' + today.toLocaleDateString('fr-FR', { weekday: 'long' }).toUpperCase();

  return (
    <div className="ta-mobile-hub is-open" role="dialog" aria-label="Navigation">
      <div className="ta-mobile-hub-top">
        <div style={{ minWidth: 0 }}>
          <div style={{ fontFamily: 'var(--font-mono)', fontSize: 9, letterSpacing: '0.18em', color: 'var(--ink-3)' }}>
            {dateStr}
          </div>
          <div className="ta-mobile-hub-title">TheApp</div>
        </div>
        <button onClick={onClose} aria-label="Fermer"
          style={{
            width: 40, height: 40, display: 'grid', placeItems: 'center',
            color: 'var(--ink-3)', background: 'transparent', border: '1px solid var(--rule-2)',
            cursor: 'pointer', flex: '0 0 40px',
          }}>
          {Ic.close}
        </button>
      </div>

      <div className="ta-mobile-hub-grid">
        {NAV.map((item) => {
          const active = item.path === '/'
            ? location.pathname === '/'
            : location.pathname.startsWith(item.path);
          return (
            <Link
              key={item.id}
              to={item.path}
              onClick={onClose}
              className={`ta-mobile-hub-cell ${active ? 'is-active' : ''}`}
            >
              <span className="n">{item.n}</span>
              <span className="ic">{Ic[item.icon]}</span>
              <span className="l">{item.label}</span>
            </Link>
          );
        })}
      </div>

      <div className="ta-mobile-hub-foot">
        <button
          onClick={toggleTheme}
          style={{
            display: 'flex', alignItems: 'center', justifyContent: 'space-between',
            padding: '14px 18px',
            color: 'var(--ink)', background: 'var(--bg-1)',
            border: '1px solid var(--rule-2)',
            fontFamily: 'var(--font-mono)', fontSize: 11,
            letterSpacing: '0.14em', textTransform: 'uppercase',
            cursor: 'pointer', width: '100%',
          }}
        >
          <span style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <span style={{ width: 18, height: 18, display: 'grid', placeItems: 'center', color: 'var(--accent)' }}>
              {theme === 'dark' ? Ic.sun : Ic.moon}
            </span>
            Mode {theme === 'dark' ? 'clair' : 'sombre'}
          </span>
          <span style={{ color: 'var(--ink-4)' }}>→</span>
        </button>

        <button
          onClick={() => { onLogout && onLogout(); onClose(); }}
          style={{
            display: 'flex', alignItems: 'center', justifyContent: 'space-between',
            padding: '14px 18px',
            color: 'var(--ink-3)', background: 'transparent',
            border: '1px solid var(--rule-2)',
            fontFamily: 'var(--font-mono)', fontSize: 11,
            letterSpacing: '0.14em', textTransform: 'uppercase',
            cursor: 'pointer', width: '100%',
          }}
        >
          <span style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <span style={{ width: 18, height: 18, display: 'grid', placeItems: 'center' }}>
              {Ic.logout}
            </span>
            Déconnexion
          </span>
          <span style={{ color: 'var(--ink-4)' }}>→</span>
        </button>
      </div>
    </div>
  );
}
